// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28CcU","colBig":"styles_colBig__1ySm9","colSmall":"styles_colSmall__1U1BG","shopifyNameWrapper":"styles_shopifyNameWrapper__1Wf3G"};